"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('button', {
    staticClass: "el-button",
    "class": [_vm.type ? 'el-button--' + _vm.type : '', _vm.buttonSize ? 'el-button--' + _vm.buttonSize : '', {
      'is-disabled': _vm.buttonDisabled,
      'is-loading': _vm.loading,
      'is-plain': _vm.plain,
      'is-round': _vm.buttonRound,
      'is-circle': _vm.circle,
      'is-noLabel': _vm.noLabel
    }],
    attrs: {
      "disabled": _vm.buttonDisabled || _vm.loading,
      "autofocus": _vm.autofocus,
      "type": _vm.nativeType
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm.loading ? _c('i', {
    staticClass: "el-icon-loading",
    attrs: {}
  }) : _vm._e(), _vm._v(" "), _vm.icon && !_vm.loading ? _c('i', {
    "class": _vm.icon,
    attrs: {}
  }) : _vm._e(), _vm._v(" "), _vm.$slots["default"] ? _c('span', [_vm._t("default", null, {})], 2) : _vm._e()]);
};

var __vue_staticRenderFns__ = [];
var _default = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'ElButton',
  inject: {
    elForm: {
      "default": ''
    },
    elFormItem: {
      "default": ''
    }
  },
  props: {
    type: {
      type: String,
      "default": 'default'
    },
    icon: {
      type: String,
      "default": ''
    },
    nativeType: {
      type: String,
      "default": 'button'
    },
    loading: Boolean,
    disabled: [Boolean, Function],
    plain: Boolean,
    autofocus: Boolean,

    /** *扩展 */
    round: {
      type: Boolean,
      "default": true
    },
    isRound: {
      // 全局直角下设置特定圆角
      type: Boolean,
      "default": false
    },
    size: {
      type: String,
      "default": 'mini'
    },

    /** *扩展 */
    circle: Boolean
  },
  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    buttonSize: function buttonSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    buttonRound: function buttonRound() {
      if ((this.$ELEMENT || {}).btnRound === false) {
        return this.isRound || false;
      } else {
        return this.round;
      }
    },
    buttonDisabled: function buttonDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },

    /** 扩展 当label 为空 添加is-noLabel 状态样式 */
    noLabel: function noLabel() {
      return !this.$slots["default"];
    }
  },
  methods: {
    handleClick: function handleClick(evt) {
      this.$emit('click', evt);
      this.$el.blur();
    }
  }
};
exports["default"] = _default;